import { CALL_FUNDS_DISTRIBUTION_API } from '../../middleware/authHeaders'
import {
  ACCEPT_JSON_HEADERS,
  FUNDS_DISTRIBUTION_PAYMENT_PROCESSING_API_ROOT,
} from '../../config/api'
import {
  infoNotification,
  successNotification,
  errorNotification,
} from '../application/notifications'

export const POST_PROCESSING_CREATE_PAYMENTS_REQUEST = 'POST_PROCESSING_CREATE_PAYMENTS_REQUEST'
export const POST_PROCESSING_CREATE_PAYMENTS_SUCCESS = 'POST_PROCESSING_CREATE_PAYMENTS_SUCCESS'
export const POST_PROCESSING_CREATE_PAYMENTS_FAILURE = 'POST_PROCESSING_CREATE_PAYMENTS_FAILURE'

export const createPayments = (accountId, paymentProcessors) => dispatch => {
  dispatch({
    [CALL_FUNDS_DISTRIBUTION_API]: {
      method: 'POST',
      endpoint: `${FUNDS_DISTRIBUTION_PAYMENT_PROCESSING_API_ROOT}/processing/create-payments`,
      types: [
        POST_PROCESSING_CREATE_PAYMENTS_REQUEST,
        POST_PROCESSING_CREATE_PAYMENTS_SUCCESS,
        POST_PROCESSING_CREATE_PAYMENTS_FAILURE,
      ],
      headers: {
        ...ACCEPT_JSON_HEADERS,
      },
      body: JSON.stringify({
        accountId,
        paymentProcessors,
      }),
    },
  }).then(response => {
    if (response.error) {
      dispatch(
        errorNotification({
          body: `Error creating payments`,
          dismissInSeconds: 10,
        })
      )
    } else {
      dispatch(
        successNotification({
          body: `Payment creation successful`,
          dismissInSeconds: 5,
        })
      )
    }
  })
}

export const POST_PROCESSING_PROCESS_PAYMENT_REQUEST = 'POST_PROCESSING_PROCESS_PAYMENT_REQUEST'
export const POST_PROCESSING_PROCESS_PAYMENT_SUCCESS = 'POST_PROCESSING_PROCESS_PAYMENT_SUCCESS'
export const POST_PROCESSING_PROCESS_PAYMENT_FAILURE = 'POST_PROCESSING_PROCESS_PAYMENT_FAILURE'

export const processPayment = paymentId => dispatch => {
  dispatch({
    [CALL_FUNDS_DISTRIBUTION_API]: {
      method: 'POST',
      endpoint: `${FUNDS_DISTRIBUTION_PAYMENT_PROCESSING_API_ROOT}/processing/process-payment`,
      types: [
        POST_PROCESSING_PROCESS_PAYMENT_REQUEST,
        POST_PROCESSING_PROCESS_PAYMENT_SUCCESS,
        POST_PROCESSING_PROCESS_PAYMENT_FAILURE,
      ],
      headers: {
        ...ACCEPT_JSON_HEADERS,
      },
      body: JSON.stringify({
        paymentId,
      }),
    },
  }).then(response => {
    if (response.error) {
      dispatch(
        errorNotification({
          body: `Error processing single payment`,
          dismissInSeconds: 10,
        })
      )
    } else {
      dispatch(
        infoNotification({
          body: `Single payment processed`,
          dismissInSeconds: 5,
        })
      )
    }
  })
}

export const POST_PROCESSING_DELETE_PAYMENT_REQUEST = 'POST_PROCESSING_DELETE_PAYMENT_REQUEST'
export const POST_PROCESSING_DELETE_PAYMENT_SUCCESS = 'POST_PROCESSING_DELETE_PAYMENT_SUCCESS'
export const POST_PROCESSING_DELETE_PAYMENT_FAILURE = 'POST_PROCESSING_DELETE_PAYMENT_FAILURE'

export const deletePayment = paymentId => dispatch => {
  dispatch({
    [CALL_FUNDS_DISTRIBUTION_API]: {
      method: 'POST',
      endpoint: `${FUNDS_DISTRIBUTION_PAYMENT_PROCESSING_API_ROOT}/processing/delete-payment`,
      types: [
        POST_PROCESSING_DELETE_PAYMENT_REQUEST,
        POST_PROCESSING_DELETE_PAYMENT_SUCCESS,
        POST_PROCESSING_DELETE_PAYMENT_FAILURE,
      ],
      headers: {
        ...ACCEPT_JSON_HEADERS,
      },
      body: JSON.stringify({
        paymentId,
      }),
    },
  }).then(response => {
    if (response.error) {
      dispatch(
        errorNotification({
          body: `Error deleting single payment`,
          dismissInSeconds: 10,
        })
      )
    } else {
      dispatch(
        infoNotification({
          body: `Single payment deleted`,
          dismissInSeconds: 5,
        })
      )
    }
  })
}

export const POST_PROCESSING_RELEASE_PAYMENT_REQUEST = 'POST_PROCESSING_RELEASE_PAYMENT_REQUEST'
export const POST_PROCESSING_RELEASE_PAYMENT_SUCCESS = 'POST_PROCESSING_RELEASE_PAYMENT_SUCCESS'
export const POST_PROCESSING_RELEASE_PAYMENT_FAILURE = 'POST_PROCESSING_RELEASE_PAYMENT_FAILURE'

export const releasePayment = paymentId => dispatch => {
  dispatch({
    [CALL_FUNDS_DISTRIBUTION_API]: {
      method: 'POST',
      endpoint: `${FUNDS_DISTRIBUTION_PAYMENT_PROCESSING_API_ROOT}/processing/release-payment`,
      types: [
        POST_PROCESSING_RELEASE_PAYMENT_REQUEST,
        POST_PROCESSING_RELEASE_PAYMENT_SUCCESS,
        POST_PROCESSING_RELEASE_PAYMENT_FAILURE,
      ],
      headers: {
        ...ACCEPT_JSON_HEADERS,
      },
      body: JSON.stringify({
        paymentId,
      }),
    },
  }).then(response => {
    if (response.error) {
      dispatch(
        errorNotification({
          body: `Error releasing single payment`,
          dismissInSeconds: 10,
        })
      )
    } else {
      dispatch(
        infoNotification({
          body: `Single payment released`,
          dismissInSeconds: 5,
        })
      )
    }
  })
}

export const POST_PROCESSING_RELEASE_SUBMISSION_PAYMENTS_REQUEST =
  'POST_PROCESSING_RELEASE_SUBMISSION_PAYMENTS_REQUEST'
export const POST_PROCESSING_RELEASE_SUBMISSION_PAYMENTS_SUCCESS =
  'POST_PROCESSING_RELEASE_SUBMISSION_PAYMENTS_SUCCESS'
export const POST_PROCESSING_RELEASE_SUBMISSION_PAYMENTS_FAILURE =
  'POST_PROCESSING_RELEASE_SUBMISSION_PAYMENTS_FAILURE'
export const SET_PROCESSING_RELEASE_SUBMISSION_PAYMENTS_RESPONSE =
  'SET_PROCESSING_RELEASE_SUBMISSION_PAYMENTS_RESPONSE'

export const releaseSubmissionPayments = submissionList => dispatch => {
  dispatch({
    [CALL_FUNDS_DISTRIBUTION_API]: {
      method: 'POST',
      endpoint: `${FUNDS_DISTRIBUTION_PAYMENT_PROCESSING_API_ROOT}/processing/release-submission-payments`,
      types: [
        POST_PROCESSING_RELEASE_SUBMISSION_PAYMENTS_REQUEST,
        POST_PROCESSING_RELEASE_SUBMISSION_PAYMENTS_SUCCESS,
        POST_PROCESSING_RELEASE_SUBMISSION_PAYMENTS_FAILURE,
      ],
      headers: {
        ...ACCEPT_JSON_HEADERS,
      },
      body: JSON.stringify({
        submissionList,
      }),
    },
  }).then(response => {
    if (response.error) {
      const message = response.payload?.response
      if (message) {
        dispatch({
          type: SET_PROCESSING_RELEASE_SUBMISSION_PAYMENTS_RESPONSE,
          payload: { response: message },
        })
      } else {
        dispatch(
          errorNotification({
            body: `Error releasing submission payments`,
            dismissInSeconds: 10,
          })
        )
      }
    }
  })
}

export const POST_PROCESSING_PROCESS_ALL_PAYMENTS_REQUEST =
  'POST_PROCESSING_PROCESS_ALL_PAYMENTS_REQUEST'
export const POST_PROCESSING_PROCESS_ALL_PAYMENTS_SUCCESS =
  'POST_PROCESSING_PROCESS_ALL_PAYMENTS_SUCCESS'
export const POST_PROCESSING_PROCESS_ALL_PAYMENTS_FAILURE =
  'POST_PROCESSING_PROCESS_ALL_PAYMENTS_FAILURE'

export const processAllPayments = (accountId, numberOfPayments) => dispatch => {
  dispatch({
    [CALL_FUNDS_DISTRIBUTION_API]: {
      method: 'POST',
      endpoint: `${FUNDS_DISTRIBUTION_PAYMENT_PROCESSING_API_ROOT}/processing/start-processing`,
      types: [
        POST_PROCESSING_PROCESS_ALL_PAYMENTS_REQUEST,
        POST_PROCESSING_PROCESS_ALL_PAYMENTS_SUCCESS,
        POST_PROCESSING_PROCESS_ALL_PAYMENTS_FAILURE,
      ],
      headers: {
        ...ACCEPT_JSON_HEADERS,
      },
      body: JSON.stringify({
        accountId,
        numberOfPayments,
      }),
    },
  }).then(response => {
    if (response.error) {
      dispatch(
        errorNotification({
          body: `Error queueing payments for processing`,
          dismissInSeconds: 10,
        })
      )
    } else {
      dispatch(
        infoNotification({
          body: `Payments queued for processing`,
          dismissInSeconds: 5,
        })
      )
    }
  })
}

export const POST_PROCESSING_STOP_PROCESSING_ALL_PAYMENTS_REQUEST =
  'POST_PROCESSING_STOP_PROCESSING_ALL_PAYMENTS_REQUEST'
export const POST_PROCESSING_STOP_PROCESSING_ALL_PAYMENTS_SUCCESS =
  'POST_PROCESSING_STOP_PROCESSING_ALL_PAYMENTS_SUCCESS'
export const POST_PROCESSING_STOP_PROCESSING_ALL_PAYMENTS_FAILURE =
  'POST_PROCESSING_STOP_PROCESSING_ALL_PAYMENTS_FAILURE'

export const stopProcessingAllPayments = () => dispatch => {
  dispatch({
    [CALL_FUNDS_DISTRIBUTION_API]: {
      method: 'POST',
      endpoint: `${FUNDS_DISTRIBUTION_PAYMENT_PROCESSING_API_ROOT}/processing/stop-processing`,
      types: [
        POST_PROCESSING_STOP_PROCESSING_ALL_PAYMENTS_REQUEST,
        POST_PROCESSING_STOP_PROCESSING_ALL_PAYMENTS_SUCCESS,
        POST_PROCESSING_STOP_PROCESSING_ALL_PAYMENTS_FAILURE,
      ],
      headers: {
        ...ACCEPT_JSON_HEADERS,
      },
      body: JSON.stringify({}),
    },
  }).then(response => {
    if (response.error) {
      dispatch(
        errorNotification({
          body: `Error emptying payment queue`,
          dismissInSeconds: 10,
        })
      )
    } else {
      dispatch(
        infoNotification({
          body: `Payment queue is emptying`,
          dismissInSeconds: 5,
        })
      )
    }
  })
}

export const GET_PROCESSING_PAYMENTS_CREATION_STATUS_REQUEST =
  'GET_PROCESSING_PAYMENTS_CREATION_STATUS_REQUEST'
export const GET_PROCESSING_PAYMENTS_CREATION_STATUS_SUCCESS =
  'GET_PROCESSING_PAYMENTS_CREATION_STATUS_SUCCESS'
export const GET_PROCESSING_PAYMENTS_CREATION_STATUS_FAILURE =
  'GET_PROCESSING_PAYMENTS_CREATION_STATUS_FAILURE'

export const getPaymentCreationStatus = () => dispatch => {
  dispatch({
    [CALL_FUNDS_DISTRIBUTION_API]: {
      method: 'GET',
      endpoint: `${FUNDS_DISTRIBUTION_PAYMENT_PROCESSING_API_ROOT}/processing/status/payment-creation`,
      types: [
        GET_PROCESSING_PAYMENTS_CREATION_STATUS_REQUEST,
        GET_PROCESSING_PAYMENTS_CREATION_STATUS_SUCCESS,
        GET_PROCESSING_PAYMENTS_CREATION_STATUS_FAILURE,
      ],
      headers: {
        ...ACCEPT_JSON_HEADERS,
      },
    },
  })
}

export const GET_PROCESSING_PAYMENTS_PROCESSING_STATUS_REQUEST =
  'GET_PROCESSING_PAYMENTS_PROCESSING_STATUS_REQUEST'
export const GET_PROCESSING_PAYMENTS_PROCESSING_STATUS_SUCCESS =
  'GET_PROCESSING_PAYMENTS_PROCESSING_STATUS_SUCCESS'
export const GET_PROCESSING_PAYMENTS_PROCESSING_STATUS_FAILURE =
  'GET_PROCESSING_PAYMENTS_PROCESSING_STATUS_FAILURE'

export const getProcessingPaymentsStatus = () => dispatch => {
  dispatch({
    [CALL_FUNDS_DISTRIBUTION_API]: {
      method: 'GET',
      endpoint: `${FUNDS_DISTRIBUTION_PAYMENT_PROCESSING_API_ROOT}/processing/status/payment-processing`,
      types: [
        GET_PROCESSING_PAYMENTS_PROCESSING_STATUS_REQUEST,
        GET_PROCESSING_PAYMENTS_PROCESSING_STATUS_SUCCESS,
        GET_PROCESSING_PAYMENTS_PROCESSING_STATUS_FAILURE,
      ],
      headers: {
        ...ACCEPT_JSON_HEADERS,
      },
    },
  })
}

// SELECTORS
export const selectProcessing = state => state.fundsDistribution.processing
export const selectCreatePaymentsStatus = state => selectProcessing(state).paymentCreationStatus
export const selectProcessingPaymentsStatus = state =>
  selectProcessing(state).paymentProcessingStatus
export const selectProcessingReleaseSubmissionPaymentsResponse = state =>
  selectProcessing(state).releaseSubmissionPaymentsResponse

// STATE
const INITIAL_STATE = {
  paymentCreationStatus: {
    totalTransactions: 0,
    remainingTransactions: 0,
  },
  paymentProcessingStatus: [],
  releaseSubmissionPaymentsResponse: '',
}

// REDUCERS
const processing = (state = INITIAL_STATE, { type, payload } = {}) =>
  ({
    [GET_PROCESSING_PAYMENTS_CREATION_STATUS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      paymentCreationStatus: { ...newPayload },
    }),
    [GET_PROCESSING_PAYMENTS_PROCESSING_STATUS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      paymentProcessingStatus: [...newPayload],
    }),
    [SET_PROCESSING_RELEASE_SUBMISSION_PAYMENTS_RESPONSE]: (currentState, newPayload) => ({
      ...currentState,
      releaseSubmissionPaymentsResponse: newPayload.response,
    }),
    [POST_PROCESSING_RELEASE_SUBMISSION_PAYMENTS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      releaseSubmissionPaymentsResponse: newPayload,
    }),
  }[type]?.(state, payload) || state)

export default processing
